import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-directions",
  "use": "icon-ic-directions-usage",
  "viewBox": "0 0 24 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 25\" id=\"icon-ic-directions\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.5 7.135a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm1.5-7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm2-7a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H9Zm-1 7a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H9a1 1 0 0 1-1-1Zm1 5a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H9Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol